module.exports = __webpack_public_path__ + "media/images/animations/tire_widths/2-31e6334543ab0cfbdc286598b50888f2.png";